import Typography from "@material-ui/core/Typography";
import React, { FC } from "react";

import classes from "./CampaignCreationSlideContainer.module.scss";

type CampaignCreationSlideContainerProps = {
  heading?: string;
  children: React.ReactNode;
};

const CampaignCreationSlideContainer: FC<CampaignCreationSlideContainerProps> = ({ heading, children }) => {
  return (
    <div className={classes.container}>
      {heading ? <Typography variant="h2">{heading}</Typography> : null}
      {children}
    </div>
  );
};

export default CampaignCreationSlideContainer;
